import CategoriesService from "services/CategoriesService";

const { createAsyncThunk, createSlice } = require("@reduxjs/toolkit");

export const getCategories = createAsyncThunk(
    "categories/getAll",
    async (_, { rejectWithValue }) => {
        try {
            const response = await CategoriesService.getCategories();
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response || "Internal server error");
        }
    }
);

export const getCategoryById = createAsyncThunk(
    "categories/getCategoryById",
    async (id, { rejectWithValue }) => {
        try {
            const response = await CategoriesService.getCategoryById(id);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response || "Internal server error");
        }
    }
);

export const createCategory = createAsyncThunk(
    "categories/createCategory",
    async (data, { rejectWithValue }) => {
        try {
            console.log("data: ", data);
            const response = await CategoriesService.createCategory(data);
            return response.data.category;
        } catch (error) {
            return rejectWithValue(
                error.response.data.error || "Internal server error"
            );
        }
    }
);

export const updateCategoryById = createAsyncThunk(
    "categories/updateCategoryById",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await CategoriesService.updateCategory(id, data);
            return response.data.category;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Internal server error"
            );
        }
    }
);

export const deleteCategoryById = createAsyncThunk(
    "categories/deleteCategoryById",
    async (id, { rejectWithValue }) => {
        try {
            // TODO: this is supposed to return the deleted category id, but the API returns only a status message
            await CategoriesService.deleteCategoryById(id);
            return id;
        } catch (error) {
            return rejectWithValue(error.response || "Internal server error");
        }
    }
);

const initialState = {
    categories: [],
    category: null,
    loading: false,
    error: null,
};

const categoriesSlice = createSlice({
    name: "categories",
    initialState,
    reducers: {
        setCategories: (state, { payload }) => {
            state.categories = payload;
        },
        setCategory: (state, { payload }) => {
            state.category = payload;
        },
        setLoading: (state, { payload }) => {
            state.loading = payload;
        },
        setError: (state, { payload }) => {
            state.error = payload;
        },
    },
    extraReducers: {
        [getCategories.pending]: (state) => {
            state.loading = true;
        },
        [getCategories.fulfilled]: (state, { payload }) => {
            state.categories = payload;
            state.loading = false;
        },
        [getCategories.rejected]: (state, { payload }) => {
            state.error = payload;
            state.loading = false;
        },
        [getCategoryById.pending]: (state) => {
            state.loading = true;
        },
        [getCategoryById.fulfilled]: (state, { payload }) => {
            state.category = payload;
            state.loading = false;
        },
        [getCategoryById.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        [createCategory.pending]: (state, { payload }) => {
            state.loading = true;
        },
        [createCategory.fulfilled]: (state, { payload }) => {
            state.categories.push(payload);
            state.loading = false;
        },
        [createCategory.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        [updateCategoryById.pending]: (state) => {
            state.loading = true;
        },
        [updateCategoryById.fulfilled]: (state, { payload }) => {
            state.categories = state.categories.map((category) =>
                category._id === payload._id ? payload : category
            );
            state.loading = false;
        },
        [updateCategoryById.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        [deleteCategoryById.pending]: (state) => {
            state.loading = true;
        },
        [deleteCategoryById.fulfilled]: (state, { payload }) => {
            state.categories = state.categories.filter(
                (category) => category._id !== payload
            );
            state.loading = false;
        },
        [deleteCategoryById.rejected]: (state, { payload }) => {
            state.loading = false;
        },
    },
});

export const { setCategories, setCategory, setLoading, setError } =
    categoriesSlice.actions;

export default categoriesSlice.reducer;
